import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { DeliveryZone } from '../types/delivery-zone.type';
import { ADMIN_DELIVERY_ZONES_API_PATHS } from '../constants/delivery-zones-api-paths.constants';

type UseArchiveDeliveryZoneResult = {
  archiveDeliveryZone: (deliveryZoneId: string) => Promise<DeliveryZone | null>;
  isSubmitting: boolean;
};

export function useArchiveDeliveryZone(): UseArchiveDeliveryZoneResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const archiveDeliveryZone = async (deliveryZoneId: string): Promise<DeliveryZone | null> => {
    setIsSubmitting(true);

    try {
      const archivedDeliveryZone = await HttpClient.delete<DeliveryZone>(
        ADMIN_DELIVERY_ZONES_API_PATHS.ARCHIVE_DELIVERY_ZONE(deliveryZoneId)
      );

      enqueueSnackbar('Zone de livraison archivée', { variant: 'success' });
      return archivedDeliveryZone;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de l'archivage de la zone de livraison"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { archiveDeliveryZone, isSubmitting };
}
